<app-icon-sort-alpha-down *ngIf="type === 'ztoa'" [size]="size" [color]="color"></app-icon-sort-alpha-down>
<app-icon-sort-alpha-up *ngIf="type === 'atoz'" [size]="size" [color]="color"></app-icon-sort-alpha-up>
<app-icon-time *ngIf="type === 'time'" [size]="size" [color]="color"></app-icon-time>
<app-icon-flame *ngIf="type === 'flame'" [size]="size" [color]="color"></app-icon-flame>
<app-icon-star *ngIf="type === 'star'" [size]="size" [color]="color"></app-icon-star>